// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + (chunkId === 644 ? "lang-zh-Hant-js" : chunkId) + ".chunk.1793293142674.js";
};